import React, { useState } from 'react';

export default function EditIcon({ color = '#FFFFFF', className, click }) {
    const [isHovered, setIsHovered] = useState(false);

    const currentColor = color;

    return (
        <svg
            height={16}
            width={16}
            fill="none"
            viewBox="0 0 24 24"
            className={className}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={click}
        >
            <path
                stroke={currentColor}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.862 3.487a2.081 2.081 0 0 1 2.946 2.946L8.251 17.99 4 19l1.01-4.251 11.852-11.262z"
            />
        </svg>
    );
}